<script setup lang="ts">
import translaters from '@/tradutors/assine';

const route = useRoute()
const reactiveLocale = computed(() => route.params.language) // Certifique-se de que locale é uma ref

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

</script>

<template>
    <div class="row">
        <div class="col-lg-7 col-12">
            <div class="title">{{ translate.credits.title }}</div>
            <div class="subtitle col-9">{{ translate.credits.subTitle }}</div>
        </div>
        <div class="col-lg-5 col-12">
            <ul class="bulleted-list">
                <li v-for="(list, index) in translate.credits.listBenefits" :key="index">
                    <p v-html="list"></p>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="css">
.title {
    font-family: 'Bebas-Neue';
    font-weight: 300;
    font-size: 35.44px;
    line-height: 35.44px;
    color: #000000;    
}

.subtitle {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 18.13px;
    line-height: 21.75px;
    color: #ff6000;    
    margin-top: 10px;
}

.list-items{
    font-size: 15px;
}

.footer-list {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    font-style: italic;
    letter-spacing: 0;
    line-height: 15px;
    padding-top: 30px;
}

.bulleted-list {
    margin-top: -5px;
    list-style-type: disc;    
}
.bulleted-list li {
    color: #000000;
    font-family: 'Exo-2';
    font-size: 15.15px;
    line-height: 22.73px;    
}

</style>